import React, { useEffect } from "react";
import { Form, Input, Select } from 'antd';
import FormItem from "components/fields/FormItem";
import { connect } from "react-redux";
import { 
	getTrainingClassParticipantDetails, 
	doTrainingClassParticipantCreate, 
	doTrainingClassParticipantUpdate,  
} from "../../../../../redux/trainingclass/trainingClassState";
import CrudButtons from "components/button/crudbuttons";
import { requiredField } from "utils/crudSagaHelper";
import { getLabel } from "utils";

const TrainingClassParticipantForm = ({
	doCreate, 
	doUpdate, 
	onCancel, 
	recordData,
	classeId,
	getDetails,
	submitLabel,
	...props
 }) => {
		
  	const [form] = Form.useForm();
  	const { recordId, mode } = props;

	
	useEffect(() => {	
	if (recordData) {
		form.resetFields();
			
			const { class_participants, ...rest } = recordData;

			const initialValues = {
				...rest,
				tcp_class_id: classeId,
				tcp_user_id: class_participants?.map(p => p.tcp_user_id) || [],
			};

			form.setFieldsValue(initialValues);
		}
	}, [recordData, classeId, form]);

	useEffect(() => {
		if (classeId && recordId === 0) {
			getDetails({ classeId, participantId: 0 });
		} else if (classeId && recordId) {
			getDetails({ classeId, participantId: recordId });
		}
	}, [classeId, recordId, getDetails]);
   

	const onSubmit = (formData) => {
		try { 
			formData.tcp_class_id=classeId;
		if (!formData.tcp_user_id || formData.tcp_user_id === 0) {
      		delete formData.clm_user_id;}

			recordData?.tcp_id > 0 ? doUpdate(formData): doCreate(formData);
		} catch (error) {
			console.error('Save failed:', error);
		}
		
};


  
  	return (
		<Form 	layout="vertical"
				form={form}
				onFinish={onSubmit}
				className={mode !== "view" ? "form" : ""}
		>

		<FormItem 
			name="tcp_id" 
			hidden
		>
			<Input type="hidden" />

		</FormItem>

		<div className="col-span-3">
			<FormItem
					name="tcp_user_id"
					label="Select Participants"
					rules={[requiredField]}
					>
					{mode !== "view" ? 
						<Select id="tcp_user_id"
						mode="multiple"
						placeholder="Select participants"
						allowClear
						showSearch
						optionFilterProp="label"
						options={recordData?.participantOptionList}
						onChange={(values) =>
							form.setFieldsValue({
								tcp_user_id: values.length ? values : null,
							})
						}
						maxTagCount="responsive"
						style={{ width: "100%" }}
						/>
						:
						<label className="text-base label-value dark:text-white">
							{getLabel(recordData?.participantOptionList, recordData?.tcp_user_id)}
						</label>
					}
			</FormItem>
      	</div>

		{mode === "edit" && (
			<div className="w-full flex justify-end">
				<CrudButtons
					mode={mode}
					recordId={recordData?.tcp_id ?? 0}
					isModal={true}
					allowEdit={false}
					modalId={
					recordData?.tcp_id > 0
						? "edit_class_participants"
						: "add_class_participants"
					}
					cancelLabel="Cancel"
					doHideModal={onCancel}
					submitLabel={submitLabel}
				/>
			</div>
      	)}
    </Form> 	
  	);
};

const mapStateToProps = (state) => ({
  	recordData: state.trainingClass.trainingClassParticipantDetails?.data,
});

const mapDispatchToProps = (dispatch) => ({
	getDetails: (data) => dispatch(getTrainingClassParticipantDetails(data)),
  	doCreate: (data) => dispatch(doTrainingClassParticipantCreate(data)),
  	doUpdate: (data) => dispatch(doTrainingClassParticipantUpdate(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(TrainingClassParticipantForm);
